import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Description = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          totalWineries
        }
      }
    }
  `);
  return (
    <StyledSection>
      <Title>
        Start your free 30-day trial and join the{' '}
        {data.site.siteMetadata.totalWineries} wineries already using Commerce7
      </Title>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  text-align: center;
  margin-bottom: 100px;
`;

const Title = styled.h2`
  color: var(--blue-dark);
  font-size: var(--heading-size-sm);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-wide);
  margin-bottom: 15px;
`;

export default Description;
